import Add from '@material-ui/icons/Add'
import { useEffect, useRef, useState } from 'react'
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import Modal from '../../components/UI/Modal/Modal'
import Search from '../../components/UI/Search/Search'
import Spinner from '../../components/UI/Spinner/Spinner'
import Table from '../../components/UI/Table/Table'
import UserForm from '../../components/User/UserForm/UserForm'
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'
import './Users.css'

const Users = () => {
    const [searchParams, setSearchParams] = useState({
        username: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام کاربری'
            },
            validation: {
                required: false
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const [view, setView] = useState(false)
    const [userId, setUserId] = useState('')
    const [pageCount, setPageCount] = useState(0)
    const [userInfo, setUserInfo] = useState('')
    const [rerender, setRerender] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [pageIndex, setPageIndex] = useState(0)
    const [tableData, setTableData] = useState([])
    const [modalContent, setModalContent] = useState('')
    const ref = useRef();

    useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, []);

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls);
    }

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "user": {
                "username": searchParams.username.value
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/users/getUsers'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.users)
                    pushData(newList)
                    setUserList(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'userNameAndLastName',
                header: "نام و نام خانوادگی",
                align: 'center',
            },
            {
                accessorKey: 'username',
                header: "نام کاربری",
                align: 'center',
            },
            {
                accessorKey: 'cellNumber',
                header: "تلفن همراه",
                align: 'center',
            },
            {
                accessorKey: 'isActive',
                header: "وضعیت کاربر",
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                userNameAndLastName: d.name + " " + d.lastname,
                username: d.username,
                cellNumber: d.cellNumber,
                isActive: d.isActive == '1' ? 'فعال است' : 'فعال نیست',
                subRows: [],
            });
        })
        buttons.push({ id: 1, text: 'ویرایش', clicked: editUser });
        buttons.push({ id: 2, text: 'مشاهده', clicked: viewUser });
        buttons.push({ id: 3, text: 'تغییر وضعیت', clicked: changeStateUser });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }
    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearchParams(srch)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const addNewUser = (event) => {
        setIsUpdate(false)
        setModalContent(<UserForm view={false} loadUsers={search} closeUserModal={closeUserModal} isUpdate={false} />);
        ref.current.openModal()
    }
    const afterCloseModal = (event) => {
        setView(false)
    }

    const changeStateUser = (id) => {
        setUserId(id)
        setModalContent(<div className="row justify-content-center">
            <div className="UserChangeState">
                <div className="row justify-content-center">
                    آیا از تغییر وضعیت کاربر مطمئن هستید؟
                </div>
                <div className="row justify-content-center mt-4">
                    <Button btnType="Success" clicked={() => submitChangeState(id)}>ثبت</Button>
                </div>
            </div>
        </div>)
        ref.current.openModal()
    }
    const submitChangeState = (id) => {
        var info = {
            "user": {
                "id": id

            },
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/users/changeUserState'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                ref.current.closeModal()
                search();
            })
            .catch(error => console.log(error))
    }

    const editUser = (id, data) => {
        setLoading(true);
        var info = {
            "user": {
                "id": id
            },
            "version": "mtpx001"
        }

        var raw = JSON.stringify(info)
        var url = 'management/api/v1/users/getUserInfo'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setUserInfo(result.user)
                setLoading(false);
                setModalContent(<UserForm view={false} loadUsers={search} closeUserModal={closeUserModal} isUpdate={true} userInfo={result.user} />);
                ref.current.openModal()
                setLoading(false);
            })
            .catch(error => setLoading(false))
    }
    const viewUser = (id) => {
        setLoading(true);
        setUserId(id);
        var info = {
            "user": {
                "id": id
            },
            "version": "mtpx001"
        }

        var raw = JSON.stringify(info)
        var url = 'management/api/v1/users/getUserInfo'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setUserInfo(result.user)
                setIsUpdate(true)
                setModalContent(<UserForm view={true} loadUsers={search} closeUserModal={closeUserModal} isUpdate={true} userInfo={result.user} />);
                ref.current.openModal()
                setView(true)
                setLoading(false);
            })
            .catch(error => setLoading(true))
    }

    const closeUserModal = (event) => {
        ref.current.closeModal();
    }

    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                searchParams={true}
                col="3 mt-3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });

    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-2">
            {form}
        </div>
        <div className="row pl-3 mt-3" dir="ltr" >
            <Button btnType="SearchParams" clicked={search}>جستجو</Button>
        </div>
    </div>
    const permission = window.localStorage.getItem("permission")
    return (
        <>
            {loading ? <Spinner /> : ''}
            <Search class="orders-search" className form={form} />
            {permission.includes != null && permission.includes('USER_WRITE') ?
                <div className="row justify-content-center mt-3 ml-3">
                    <div className="UserGeneralBtn mb-2">
                        <div onClick={addNewUser} className="Add">
                            <Add className="UserIcon" />
                        </div>
                    </div>
                </div>
                : ''
            }
            <div className="row justify-content-center w-100 ml-0 mr-0">

                {rerender ?
                    // <Spinner />
                    <Table hasDetails={false} pageSize={pageSize} data={userList} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={200} loading={loading} />
                    :
                    <Table hasDetails={false} pageSize={pageSize} data={userList} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={200} loading={loading} />
                }
            </div>
            < Modal
                content={modalContent}
                ref={ref}
                closePermission={true}
                closeModal={afterCloseModal}
            />
        </>
    )
}

export default Users